app.controller("ExamsManagerGenerateSchedule", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "$uibModal", "toastr", "$timeout", "params",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, $uibModal, toastr, $timeout, params) {

        $scope.status = "processing";
        $scope.messages = [];
        $scope.info = '';

        function generate() {
            ExamsManagerService.generateExams({
                barrierEnabled: params.barrierEnabled,
                level: params.level
            }).then(function (result) {
                console.log(result);
                $scope.status = result.status;
                $scope.info = result.info;
                $scope.messages = result.messages;
            }, function () {
                $scope.status = "exception"
            });
        }

        $timeout(function () {
            // $scope.status = "success";
            // $scope.info = "informacia";

            // $scope.status = "exception";
            // $scope.status = "fail";
            // $scope.status = "fail";

            // $scope.messages = [
            //     {name: "erti", value: "123"},
            //     {name: "erti", value: 123},
            //     {name: "erti", value: "saxeli gvari"}
            // ];

            generate();
        }, 100);

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
